// import React from "react";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import FooterLogo from "./assets/images/footer-logo.png"; // Adjust the path as necessary

// const Footer = () => {
//   return (
//     <footer className="bg-teal text-white ">
//       <Container className="py-5 max-1330">
//         <div className="row align-items-end g-4 p-4">


//           <Col md={12} className="mt-4 mt-md-0">
//             <Row>
//               <Col xs={12}>
//                 <div className="row g-4">
//                   <div className="col-3">
//                     <h6 className="fw-bold">ABOUT US</h6>
//                     <ul className="list-unstyled small">
//                       <li>
//                         <a href="/about?section=vision-mission">VISION AND MISSION</a>
//                       </li>
//                       <li>
//                         <a href="/about?section=governing-structure">GOVERNING STRUCTURE</a>
//                       </li>
//                       <li>
//                         <a href="/about?section=management-team">MANAGEMENT TEAM</a>
//                       </li>
//                        <li>
//                         <a href="/about?section=corporate-social-investments">CORPORATE SOCIAL INVESTMENTS</a>
//                       </li>
//                        <li>
//                         <a href="/about?section=social-mapping">SOCIAL MAPPING</a>
//                       </li>
//                     </ul>
//                   </div>
//                   <div className="col-2">
//                     <h6 className="fw-bold">QUICK DIRECTORY</h6>
//                     <ul class="list-unstyled small">
//                   <li>
//                         <a href="https://sacoronavirus.co.za/">SA Coronavirus</a>
//                       </li>
//                       <li>
//                         <a href="/contact-us?section=emergency-number">EMERGENCY NUMBER</a>
//                       </li>
//                       <li>
//                         <a href="/contact-us?section=samsa-offices">CONTACT US</a>
//                       </li>
//                       <li>
//                         <a href="/legislation?section=marine-notices">Marine Notices</a>
//                       </li>
//                       <li>
//                         <a href="/services?section=shipping-overview">SERVICE REQUEST</a>
//                       </li>
//                       <li>
//                         <a href="/services?section=forms-all">Checklists</a>
//                       </li>
//                 </ul>
//                   </div>
//                   <div className="col-3">
//                     <h6 className="fw-bold">CORPORATE RESOURCES</h6>
//                 <ul class="list-unstyled small">
//                   <li><a href="/press-room?section=publications">ANNUAL REPORTS</a></li>
//                   <li><a href="/press-room?section=events-calendar">EVENTS CALENDAR</a></li>
//                   <li><a href="/opportunities?section=vacancies">CAREERS AT SAMSA</a></li>
//                   <li><a href="/opportunities?section=maritime-careers">MARITIME GUIDANCE</a></li>
//                   <li><a href="/opportunities?section=cadetship">CADETSHIP</a></li>
//                   <li><a href="#">TENDERS</a></li>
//                   <li><a href="/press-room?section=gallery">MULTIMEDIA GALLERY</a></li>
//                 </ul>
//                   </div>
//                   <div className="col-3">
//                       <h6 className="fw-bold">COMMUNITIES</h6>
//                  <ul class="list-unstyled small">
//                   <li><a href="https://africanmarads.com/">MARADS</a></li>
//                   <li><a href="https://pccsa.org.za/">PCC-SA</a></li>
//                   <li><a href="/services?section=fishing-overview">NATIONAL FISHING FORUM</a></li>
//                   <li><a href="https://saimi.co.za/">SAIMI</a></li>
//                   <li><a href="https://www.imo.org/en/home/errorpagenotfound?aspxerrorpath=/en/pages/default.aspx">IMO</a></li>
//                   <li><a href="https://www.transport.gov.za/">DEPARTMENT OF TRANSPORT</a></li>
//                   <li><a href="https://blog.samsa.org.za/">SAMSA BLOG</a></li>
//                 </ul>
//                   </div>
//                    <div className="col-1">
//             <img
//               src={FooterLogo} // Replace with your logo
//               alt="SAMSA Logo"
//               height="154"
//             />
//           </div>
//                 </div>


//               </Col>

//             </Row>
//           </Col>



//           <div className="col-md d-none">
//             <div className="bg-white bg-opacity-10 p-4 rounded">
//               <h4 className="fw-bold">
//                 SUBSCRIBE
//                 <br className="d-block d-sm-none" /> TO SAMSA BLOG
//               </h4>
//               <Form className="d-flex flex-column flex-sm-row mt-3 mb-2">
//                 <Form.Control
//                   type="email"
//                   placeholder="Enter email"
//                   className="me-2 bg-white bg-opacity-10 border-0 height-60 mb-2 mb-sm-0"
//                 />
//                 <Button
//                   variant="green-38B652"
//                   className="height-60 px-4 btn-green-38B652"
//                 >
//                   Subscribe
//                 </Button>
//               </Form>
//               <div className="row g-3 align-items-center">
//                 <div className="col-auto">
//                   <i className="bi bi-patch-check font-36 text-green-38B652"></i>
//                 </div>
//                 <div className="col">
//                   By Subscribing, you’re accept <strong>Privacy Policy</strong>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </Container>

//       <div className="bg-white text-center text-primary-green py-3">
//         <small>@ 2025 SAMSA. All rights Reserved</small>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


// import React from "react";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import FooterLogo from "./assets/images/footer-logo.png"; // Adjust the path as necessary
// import Chatbot from './Chatbot'; // Import the Chatbot component

// const Footer = () => {
//   return (
//     <footer className="bg-teal text-white ">
//       <Container className="py-5 max-1330">
//         <div className="row align-items-end g-4 p-4">


//           <Col md={12} className="mt-4 mt-md-0">
//             <Row>
//               <Col xs={12}>
//                 <div className="row g-4">
//                   <div className="col-3">
//                     <h6 className="fw-bold">ABOUT US</h6>
//                     <ul className="list-unstyled small">
//                       <li>
//                         <a href="/about?section=vision-mission">VISION AND MISSION</a>
//                       </li>
//                       <li>
//                         <a href="/about?section=governing-structure">GOVERNING STRUCTURE</a>
//                       </li>
//                       <li>
//                         <a href="/about?section=management-team">MANAGEMENT TEAM</a>
//                       </li>
//                        <li>
//                         <a href="/about?section=corporate-social-investments">CORPORATE SOCIAL INVESTMENTS</a>
//                       </li>
//                        <li>
//                         <a href="/about?section=social-mapping">SOCIAL MAPPING</a>
//                       </li>
//                     </ul>
//                   </div>
//                   <div className="col-2">
//                     <h6 className="fw-bold">QUICK DIRECTORY</h6>
//                     <ul class="list-unstyled small">
//                   <li>
//                         <a href="https://sacoronavirus.co.za/">SA Coronavirus</a>
//                       </li>
//                       <li>
//                         <a href="/contact-us?section=emergency-number">EMERGENCY NUMBER</a>
//                       </li>
//                       <li>
//                         <a href="/contact-us?section=samsa-offices">CONTACT US</a>
//                       </li>
//                       <li>
//                         <a href="/legislation?section=marine-notices">Marine Notices</a>
//                       </li>
//                       <li>
//                         <a href="/services?section=shipping-overview">SERVICE REQUEST</a>
//                       </li>
//                       <li>
//                         <a href="/services?section=forms-all">Checklists</a>
//                       </li>
//                 </ul>
//                   </div>
//                   <div className="col-3">
//                     <h6 className="fw-bold">CORPORATE RESOURCES</h6>
//                 <ul class="list-unstyled small">
//                   <li><a href="/press-room?section=publications">ANNUAL REPORTS</a></li>
//                   <li><a href="/press-room?section=events-calendar">EVENTS CALENDAR</a></li>
//                   <li><a href="/opportunities?section=vacancies">CAREERS AT SAMSA</a></li>
//                   <li><a href="/opportunities?section=maritime-careers">MARITIME GUIDANCE</a></li>
//                   <li><a href="/opportunities?section=cadetship">CADETSHIP</a></li>
//                   <li><a href="#">TENDERS</a></li>
//                   <li><a href="/press-room?section=gallery">MULTIMEDIA GALLERY</a></li>
//                 </ul>
//                   </div>
//                   <div className="col-3">
//                       <h6 className="fw-bold">COMMUNITIES</h6>
//                  <ul class="list-unstyled small">
//                   <li><a href="https://africanmarads.com/">MARADS</a></li>
//                   <li><a href="https://pccsa.org.za/">PCC-SA</a></li>
//                   <li><a href="/services?section=fishing-overview">NATIONAL FISHING FORUM</a></li>
//                   <li><a href="https://saimi.co.za/">SAIMI</a></li>
//                   <li><a href="https://www.imo.org/en/home/errorpagenotfound?aspxerrorpath=/en/pages/default.aspx">IMO</a></li>
//                   <li><a href="https://www.transport.gov.za/">DEPARTMENT OF TRANSPORT</a></li>
//                   <li><a href="https://blog.samsa.org.za/">SAMSA BLOG</a></li>
//                 </ul>
//                   </div>
//                    <div className="col-1">
//             <img
//               src={FooterLogo} // Replace with your logo
//               alt="SAMSA Logo"
//               height="154"
//             />
//           </div>
//                 </div>


//               </Col>

//             </Row>
//           </Col>



//           <div className="col-md d-none">
//             <div className="bg-white bg-opacity-10 p-4 rounded">
//               <h4 className="fw-bold">
//                 SUBSCRIBE
//                 <br className="d-block d-sm-none" /> TO SAMSA BLOG
//               </h4>
//               <Form className="d-flex flex-column flex-sm-row mt-3 mb-2">
//                 <Form.Control
//                   type="email"
//                   placeholder="Enter email"
//                   className="me-2 bg-white bg-opacity-10 border-0 height-60 mb-2 mb-sm-0"
//                 />
//                 <Button
//                   variant="green-38B652"
//                   className="height-60 px-4 btn-green-38B652"
//                 >
//                   Subscribe
//                 </Button>
//               </Form>
//               <div className="row g-3 align-items-center">
//                 <div className="col-auto">
//                   <i className="bi bi-patch-check font-36 text-green-38B652"></i>
//                 </div>
//                 <div className="col">
//                   By Subscribing, you’re accept <strong>Privacy Policy</strong>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <Chatbot />
//       </Container>



//       {/* Enzo AI Chatbot injected here */}
//       <Chatbot />


//       <div className="bg-white text-center text-primary-green py-3">
//         <small>@ 2025 SAMSA. All rights Reserved</small>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

// import React from "react";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import FooterLogo from "./assets/images/footer-logo.png"; // Adjust the path as necessary

// const Footer = () => {
//   return (
//     <footer className="bg-teal text-white ">
//       <Container className="py-5 max-1330">
//         <div className="row align-items-end g-4 p-4">


//           <Col md={12} className="mt-4 mt-md-0">
//             <Row>
//               <Col xs={12}>
//                 <div className="row g-4">
//                   <div className="col-3">
//                     <h6 className="fw-bold">ABOUT US</h6>
//                     <ul className="list-unstyled small">
//                       <li>
//                         <a href="/about?section=vision-mission">VISION AND MISSION</a>
//                       </li>
//                       <li>
//                         <a href="/about?section=governing-structure">GOVERNING STRUCTURE</a>
//                       </li>
//                       <li>
//                         <a href="/about?section=management-team">MANAGEMENT TEAM</a>
//                       </li>
//                        <li>
//                         <a href="/about?section=corporate-social-investments">CORPORATE SOCIAL INVESTMENTS</a>
//                       </li>
//                        <li>
//                         <a href="/about?section=social-mapping">SOCIAL MAPPING</a>
//                       </li>
//                     </ul>
//                   </div>
//                   <div className="col-2">
//                     <h6 className="fw-bold">QUICK DIRECTORY</h6>
//                     <ul class="list-unstyled small">
//                   <li>
//                         <a href="https://sacoronavirus.co.za/">SA Coronavirus</a>
//                       </li>
//                       <li>
//                         <a href="/contact-us?section=emergency-number">EMERGENCY NUMBER</a>
//                       </li>
//                       <li>
//                         <a href="/contact-us?section=samsa-offices">CONTACT US</a>
//                       </li>
//                       <li>
//                         <a href="/legislation?section=marine-notices">Marine Notices</a>
//                       </li>
//                       <li>
//                         <a href="/services?section=shipping-overview">SERVICE REQUEST</a>
//                       </li>
//                       <li>
//                         <a href="/services?section=forms-all">Checklists</a>
//                       </li>
//                 </ul>
//                   </div>
//                   <div className="col-3">
//                     <h6 className="fw-bold">CORPORATE RESOURCES</h6>
//                 <ul class="list-unstyled small">
//                   <li><a href="/press-room?section=publications">ANNUAL REPORTS</a></li>
//                   <li><a href="/press-room?section=events-calendar">EVENTS CALENDAR</a></li>
//                   <li><a href="/opportunities?section=vacancies">CAREERS AT SAMSA</a></li>
//                   <li><a href="/opportunities?section=maritime-careers">MARITIME GUIDANCE</a></li>
//                   <li><a href="/opportunities?section=cadetship">CADETSHIP</a></li>
//                   <li><a href="#">TENDERS</a></li>
//                   <li><a href="/press-room?section=gallery">MULTIMEDIA GALLERY</a></li>
//                 </ul>
//                   </div>
//                   <div className="col-3">
//                       <h6 className="fw-bold">COMMUNITIES</h6>
//                  <ul class="list-unstyled small">
//                   <li><a href="https://africanmarads.com/">MARADS</a></li>
//                   <li><a href="https://pccsa.org.za/">PCC-SA</a></li>
//                   <li><a href="/services?section=fishing-overview">NATIONAL FISHING FORUM</a></li>
//                   <li><a href="https://saimi.co.za/">SAIMI</a></li>
//                   <li><a href="https://www.imo.org/en/home/errorpagenotfound?aspxerrorpath=/en/pages/default.aspx">IMO</a></li>
//                   <li><a href="https://www.transport.gov.za/">DEPARTMENT OF TRANSPORT</a></li>
//                   <li><a href="https://blog.samsa.org.za/">SAMSA BLOG</a></li>
//                 </ul>
//                   </div>
//                    <div className="col-1">
//             <img
//               src={FooterLogo} // Replace with your logo
//               alt="SAMSA Logo"
//               height="154"
//             />
//           </div>
//                 </div>


//               </Col>

//             </Row>
//           </Col>



//           <div className="col-md d-none">
//             <div className="bg-white bg-opacity-10 p-4 rounded">
//               <h4 className="fw-bold">
//                 SUBSCRIBE
//                 <br className="d-block d-sm-none" /> TO SAMSA BLOG
//               </h4>
//               <Form className="d-flex flex-column flex-sm-row mt-3 mb-2">
//                 <Form.Control
//                   type="email"
//                   placeholder="Enter email"
//                   className="me-2 bg-white bg-opacity-10 border-0 height-60 mb-2 mb-sm-0"
//                 />
//                 <Button
//                   variant="green-38B652"
//                   className="height-60 px-4 btn-green-38B652"
//                 >
//                   Subscribe
//                 </Button>
//               </Form>
//               <div className="row g-3 align-items-center">
//                 <div className="col-auto">
//                   <i className="bi bi-patch-check font-36 text-green-38B652"></i>
//                 </div>
//                 <div className="col">
//                   By Subscribing, you’re accept <strong>Privacy Policy</strong>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </Container>

//       <div className="bg-white text-center text-primary-green py-3">
//         <small>@ 2025 SAMSA. All rights Reserved</small>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import FooterLogo from "./assets/images/footer-logo.png"; // Adjust the path as necessary
import Chatbot from './Chatbot'; // Import the Chatbot component

const Footer = () => {
  return (
    <footer className="bg-teal text-white ">
      <Container className="py-5 max-1330">
        <div className="row align-items-end g-4 p-4">


          <Col md={12} className="mt-4 mt-md-0">
            <Row>
              <Col xs={12}>
                <div className="row g-4">
                  <div className="col-6 col-lg-3">
                    <h6 className="fw-bold">ABOUT US</h6>
                    <ul className="list-unstyled small">
                      <li>
                        <a href="/about?section=vision-mission">VISION AND MISSION</a>
                      </li>
                      <li>
                        <a href="/about?section=governing-structure">GOVERNING STRUCTURE</a>
                      </li>
                      <li>
                        <a href="/about?section=management-team">MANAGEMENT TEAM</a>
                      </li>

                      {/* <li>
                        <a href="/about?section=social-mapping">SOCIAL MAPPING</a>
                      </li>
                      <li>
                        <a href="/about?section=CSI-Projects">CSI-PROJECTS</a>
                      </li> */}
                    </ul>
                  </div>

                  <div className="col-6 col-lg-3">
                    <h6 className="fw-bold">CORPORATE RESOURCES</h6>
                    <ul class="list-unstyled small">
                      <li><a href="/press-room?section=publications">ANNUAL REPORTS</a></li>
                      <li><a href="/press-room?section=events-calendar">EVENTS CALENDAR</a></li>
                      <li><a href="/opportunities?section=vacancies">CAREERS AT SAMSA</a></li>
                      {/* <li><a href="/opportunities?section=maritime-careers">MARITIME GUIDANCE</a></li> */}
                      {/* <li><a href="/opportunities?section=cadetship">CADETSHIP</a></li> */}

                      {/* <li><a href="/press-room?section=gallery">MULTIMEDIA GALLERY</a></li> */}
                    </ul>
                  </div>
                  <div className="col-6 col-lg-3">
                    <h6 className="fw-bold">COMMUNITIES</h6>
                    <ul class="list-unstyled small">
                      <li><a href="https://africanmarads.com/">AAMA</a></li>
                      {/* <li><a href="https://pccsa.org.za/">PCC-SA</a></li> */}
                      {/* <li><a href="/services?section=fishing-overview">NATIONAL FISHING FORUM</a></li> */}
                      {/* <li><a href="https://saimi.co.za/">SAIMI</a></li> */}
                      <li><a href="https://www.imo.org/ ">IMO</a></li>
                      <li><a href="https://www.transport.gov.za/">DEPARTMENT OF TRANSPORT</a></li>
                      <li><a href="https://blog.samsa.org.za/">SAMSA BLOG</a></li>
                    </ul>
                  </div>
                  <div className="col-6 col-lg-2">
                    <h6 className="fw-bold">QUICK DIRECTORY</h6>
                    <ul class="list-unstyled small">
                      {/* <li>
                        <a href="https://sacoronavirus.co.za/">SA Coronavirus</a>
                      </li> */}
                      <li>
                        <a href="/opportunities?section=RFQ-Submissions">SAMSA RFQ </a>
                      </li>
                      <li>
                        <a href="/contact-us?section=emergency-number">EMERGENCY NUMBER</a>
                      </li>
                      <li>
                        <a href="/contact-us?section=samsa-offices">CONTACT US</a>
                      </li>
                      <li>
                        <a href="/legislation?section=marine-notices">MARINE NOTICES</a>
                      </li>
                      {/* <li>
                        <a href="/services?section=shipping-overview">SERVICE REQUEST</a>
                      </li> */}
                      <li>
                        <a href="/services?section=forms-all">CHECKLISTS</a>
                      </li>
                      <li><a href="/Tenders">TENDERS</a></li>
                      {/* <li><a href="https://applications.samsa.org.za/Account/Login?ReturnUrl=%2FSeafarer">VERIFICATION</a></li> */}
                       <li><a href="/services?section=seafarer-verifications">VERIFICATION</a></li>
                      <li>
                        <a href="/about?section=corporate-social-investments">CORPORATE SOCIAL INVESTMENTS</a>
                      </li>
                    </ul>
                  </div>
                  <div className="col-12 col-lg-1">
                    <img
                      src={FooterLogo} // Replace with your logo
                      alt="SAMSA Logo"
                      height="154"
                    />
                  </div>
                </div>


              </Col>

            </Row>
          </Col>



          <div className="col-md d-none">
            <div className="bg-white bg-opacity-10 p-4 rounded">
              <h4 className="fw-bold">
                SUBSCRIBE
                <br className="d-block d-sm-none" /> TO SAMSA BLOG
              </h4>
              <Form className="d-flex flex-column flex-sm-row mt-3 mb-2">
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  className="me-2 bg-white bg-opacity-10 border-0 height-60 mb-2 mb-sm-0"
                />
                <Button
                  variant="green-38B652"
                  className="height-60 px-4 btn-green-38B652"
                >
                  Subscribe
                </Button>
              </Form>
              <div className="row g-3 align-items-center">
                <div className="col-auto">
                  <i className="bi bi-patch-check font-36 text-green-38B652"></i>
                </div>
                <div className="col">
                  By Subscribing, you’re accept <strong>Privacy Policy</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Chatbot /> */}
      </Container>



      {/* Enzo AI Chatbot injected here */}
      {/* <Chatbot /> */}


      <div className="bg-white text-center text-primary-green py-3">
        <small>@ 2025 SAMSA. All rights Reserved</small>
      </div>
    </footer>
  );
};

export default Footer;